export default __webpack_public_path__ + "static/media/bbag.423aa211.jpg";